export default __webpack_public_path__ + "120a60dea1663a8ac961953a7a09c9cd.png";